<ion-app>

  <ion-menu side="start" contentId="main-content" menuId="menu-profile" type="overlay" max-edge-start="100">
    <ion-header>
      <ion-toolbar>
        <div class="toolbar-title menu-title-profile">Profile</div>
      </ion-toolbar>
    </ion-header>
    <ion-content>
       <ion-list lines="none">
        <ion-menu-toggle auto-hide="true">
          <ion-item class="menu-profile-view" (click)="this.utilsService.openProfilePage()">
            <ion-icon name="person-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-profile-view">Profile</ion-label>
          </ion-item>
          <ion-item class="menu-company-view" (click)="this.utilsService.openCompanyPage()">
            <ion-icon name="business-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-company-view">Company</ion-label>
          </ion-item>
          <ion-item class="menu-permissions-view" (click)="this.utilsService.openPermissionsPage()">
            <ion-icon name="key-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-permissions-view">Permissions</ion-label>
          </ion-item>
          <ion-item class="menu-roles-view" (click)="this.utilsService.openRolesPage()">
            <ion-icon name="person-circle-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-roles-view">Roles</ion-label>
          </ion-item>
          <ion-item class="menu-users-view" (click)="this.utilsService.openUsersPage()">
            <ion-icon name="people-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-users-view">Users</ion-label>
          </ion-item>
          <ion-item class="menu-companies-view" (click)="this.utilsService.openCompaniesPage()">
            <ion-icon name="business-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-companies-view">Companies</ion-label>
          </ion-item>
          <ion-item class="menu-admins-view" (click)="this.utilsService.openAdminsPage()">
            <ion-icon name="people-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-admins-view">Admins</ion-label>
          </ion-item>
          <ion-item class="menu-agents-view" (click)="this.utilsService.openAgentsPage()">
            <ion-icon name="people-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-agents-view">Agents</ion-label>
          </ion-item>
          <ion-item class="menu-cleaners-view" (click)="this.utilsService.openCleanersPage()">
            <ion-icon name="people-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-cleaners-view">Cleaners</ion-label>
          </ion-item>
          <ion-item class="menu-about" (click)="this.utilsService.openAboutPage()">
            <ion-icon name="information-circle-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-about">About</ion-label>
          </ion-item>
<!--           <ion-item class="menu-spacer">
          </ion-item>
          <ion-item class="menu-profile-swap-role" (click)="this.utilsService.openSwapRolePage()">
            <ion-icon name="repeat-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-profile-swap-role">Swap role</ion-label>
          </ion-item> -->
          <ion-item>
          </ion-item>
          <ion-item class="menu-profile-signout" (click)="this.utilsService.openLogoutPage()">
            <ion-icon name="exit-outline" slot="start"></ion-icon>
            <ion-label class="menu-title-profile-signout">Sign out</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list> 
    </ion-content>
  </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>